export default __webpack_public_path__ + "static/media/apple.aab86ac1.svg";